import { Button } from 'antd';
import styled from 'styled-components';

export const SubmitButton = styled(Button)`
  width: 100%;
`;
